let localLanguageOverride: string | null = null;
export function overrideLocalLanguage(language: string | null) {
  localLanguageOverride = language;
}

export function getLocalLanguage(): string {
  if (localLanguageOverride) {
    return localLanguageOverride;
  }
  if (typeof navigator !== "undefined" && navigator.language) {
    return navigator.language;
  }
  return "en-US";
}
